import { Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Customers, Features, ReviewData, Solution, Steps, WhyMedoc } from 'src/app/core/models/cms/staticData';
import { SeoMetaService } from 'src/app/core/services/seo-meta.service';
import { trigger, state, style, animate, transition } from '@angular/animations';
 
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper';
import { BookingApiService } from 'src/app/core/services/api/booking-api.service';
import { SearchParams } from 'src/app/core/models/searchParams';
import { MedocSubscription, ServicePeriodEnum } from 'src/app/core/models/cms/testimonial';
import { isPlatformBrowser } from '@angular/common';

SwiperCore.use([Pagination, Navigation , Autoplay]);
@Component({
  selector: 'app-clinic-management',
  templateUrl: './clinic-management.component.html',
  styleUrls: ['./clinic-management.component.scss'],
  animations: [
    trigger('slideIn', [
      state('void', style({ transform: 'translateX(-100%)', opacity: 0 })),
      state('*', style({ transform: 'translateX(0)', opacity: 1 })),
      transition('void => *', animate('500ms ease-in')),
    ]),
    trigger('scrollAnimation', [
      state('hidden', style({
        opacity: 0,
        transform: 'translateY(20px)'
      })),
      state('visible', style({
        opacity: 1,
        transform: 'translateY(0)'
      })),
      transition('hidden => visible', [
        animate('500ms ease-in')
      ]),
      transition('visible => hidden', [
        animate('500ms ease-out')
      ])
    ])
  ],
})
  
  
export class ClinicManagementComponent implements OnInit  {
  @ViewChild('animatedElement', { static: true }) animatedElement: ElementRef | undefined;
  customers: any[] = Customers
  features: any[] = Features
  solutions: any[] = Solution;
  steps: any[] = Steps;
  pricingData: MedocSubscription[] = [];
  reviews: any[] = ReviewData
  whymedoc : any[] = WhyMedoc
  isEnglish = true;
  animationState = false;
  isChecked = false;
  param = new SearchParams();
  recurringPeriodEnum = ServicePeriodEnum;
  isBrowser: boolean = false;
  constructor(private translateService: TranslateService,
    @Inject(PLATFORM_ID) platformId: any,
    private bookingApi :BookingApiService,
    private seo: SeoMetaService) {
    this.setLanguage();
  
    this.isBrowser = isPlatformBrowser(platformId);

    this.param.recurringPeriod = this.recurringPeriodEnum.annually;
    this.setMetaTags()
   }

  ngOnInit() {
    if (this.isBrowser) {
      this.loadSubscriptions()
    }
  }

  setMetaTags(){
    this.seo.setMetaTags(
      {
        title: 'Effective Clinic Management Software | MEDOC',
        description: "Streamline your medical practice with MEDOC - an all-in-one clinic management software. Enhance patient care, simplify administration, and boost efficiency",
        keywords: 'clinic management software, medical practice software, clinic management system, medical practice management, electronic health records, health information exchange, patient management, medical records management, healthcare solutions, medical practice optimization, digital health solutions, user-friendly healthcare software, real-time data analysis in healthcare, healthcare dashboard, medical network partners, increase patients satisfaction, global standards in healthcare management, technical support for healthcare systems, revenue cycle management in healthcare, electronic medical records, emr, ehr, medical practice efficiency, healthcare information system, patient care, medoc, clinic software, medical billing software, appointment scheduling software',
      },
      {
        title: "برنامج فعال لإدارة العيادات | MEDOC",
        description: "قم بتبسيط ممارستك الطبية مع MEDOC - برنامج شامل لإدارة العيادات. عزز رعاية المرضى، بسّط الإدارة، وزد من الكفاءة",
        keywords: "برنامج إدارة العيادات، برنامج ممارسات طبية، نظام إدارة العيادات، إدارة الممارسات الطبية، السجلات الصحية الإلكترونية، تبادل المعلومات الصحية، إدارة المرضى، إدارة السجلات الطبية، حلول الرعاية الصحية، تحسين الممارسات الطبية، حلول الصحة الرقمية، برنامج الرعاية الصحية سهل الاستخدام، التحليل الفوري للبيانات في الرعاية الصحية، لوحة معلومات الرعاية الصحية، شركاء الشبكة الطبية، زيادة رضا المرضى، المعايير العالمية في إدارة الرعاية الصحية، الدعم الفني لأنظمة الرعاية الصحية، إدارة دورة الإيرادات في الرعاية الصحية، السجلات الطبية الإلكترونية، emr، ehr، كفاءة الممارسات الطبية، نظام المعلومات الصحية، رعاية المرضى، medoc، برنامج العيادات، برنامج الفوترة الطبية، برنامج جدولة المواعيد"
      }
    );
  }
 
  loadSubscriptions() { 
     this.bookingApi.getSubscriptions(this.param).subscribe(data => {
       this.pricingData = data
    })
  }

  
  
  setLanguage() {
    this.isEnglish = this.translateService.currentLang === 'en';
    this.translateService.onLangChange.subscribe((r) => {
      this.isEnglish = r.lang == 'en';
    });
  }
}
